import { TypeBase } from '@master/model/TypeBase'
import { getRawKey } from '@master/annotation/RawKey'
import { isIgnore } from '@master/annotation/Ignore'
import { needToConvertJson } from '@master/annotation/Json'
import { get } from 'lodash/fp'

export class RequiredHours extends TypeBase {
  year: number = undefined
  ethics: number = undefined
  reg: number = undefined
  suppMs: number = undefined
  suppOthers: number = undefined
  gi: number = undefined

  constructor (type: 'req' | 'global_cpd_req' = 'req') {
    super(type)
  }

  convertToCustomRawData (keyToConvert: string[]) {
    return keyToConvert
      .filter(key => !isIgnore(this, key))
      .reduce((result, key) => {
        const snakeCaseKey = getRawKey(keyToConvert, key) || this.snakeCaseKey(key)
        let value = get(key, this)
        // convert back to stringify json
        if (needToConvertJson(this, key)) {
          value = JSON.stringify(value)
        }
        result = { ...result, [snakeCaseKey]: value }
        return result
      }, {})
  }

  allIsFilled () {
    return Object.keys(this).every(key => (typeof this[key] === 'number') || (this[key]))
  }
}
